import { render } from "./PersonalGoalsView.vue?vue&type=template&id=07bf4dc4&ts=true"
import script from "./PersonalGoalsView.vue?vue&type=script&lang=ts"
export * from "./PersonalGoalsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__